/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMilitary48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M45.694 35.5v1.103l-6.012 1.242-15.46.392v.013l-.25-.007-.25.007v-.013l-15.46-.392-6.012-1.242V35.5h43.444zm-34.972-15h-6c.235 1.382.747 2.96 3.54 3.451 1.09-.593 1.848-2.101 2.46-3.451zm27 0h5.5c.416.47-2.024 3.665-3.54 3-1.372-.258-2.004-1.609-1.96-3zm-1-16h-25l-1.372 7c15.372-4 26.372-6 26.372-6s-.229-.99 0-1z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M10.222 38.25l-6.5-.25v6.052A1.448 1.448 0 005.17 45.5h3.605c.799 0 1.447-.648 1.447-1.447V38.25zm27.5 0l6.5-.25v6.052a1.448 1.448 0 01-1.447 1.448H39.17c-.8 0-1.448-.648-1.448-1.447V38.25z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M7.722 18h31.5M12.722 32.706l-6-8.706H3.25a1.498 1.498 0 00-1.5 1.5v7.206M8.222 24h6.75M15.222 18v15h9.058M15.722 23h17M15.722 28h17M20.722 18v15'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M16.722 33H1.75v3.5l8.472 1.75h14'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M6.222 14.5l3 3M35.222 32.706l6-8.706h3.472a1.498 1.498 0 011.5 1.5v7.206M39.722 24h-6.75M9.722 18.5l1-14h26.5l1 14'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M32.722 18v15h-9.058M27.222 18v15'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M31.222 33h14.972v3.5l-8.472 1.75h-14'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M41.722 14.5l-3 3'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M7.722 18c1.656 0 3 1.345 3 3s-1.344 3-3 3c-1.655 0-3-1.345-3-3s1.345-3 3-3zm32.5 0c-1.656 0-3 1.345-3 3s1.344 3 3 3c1.655 0 3-1.345 3-3s-1.345-3-3-3zm-34-8.2a.8.8 0 00-.8-.8h-2.4a.8.8 0 00-.8.8v5.037a.8.8 0 00.8.8h2.4a.8.8 0 00.8-.8V9.8v0zm35.5 0a.8.8 0 01.8-.8h2.4a.8.8 0 01.8.8v5.037a.8.8 0 01-.8.8h-2.4a.8.8 0 01-.8-.8V9.8z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M24.222 4.5V18'
      />
    </svg>
  );
}

export default SvgMilitary48;
